export const olbContext = {
        channel: "OLB",
        type: "general",
        mappings: [
            {
                "key": "customerDashboard",
                "useDefault": true,
                "isGeneric": false,
                "useReportingData": false,
                "url": "/digital/servicing/shellapp/#/customer-dashboard",
                "categoryId":"CUSTOMER_DASHBOARD",
                "page_key": "customer-dashboard",
                "reportingData": {}
            },
            {
                "key": "kyc",
                "useDefault": true,
                "isGeneric": true,
                "useReportingData": false,
                "url": "/digital/servicing/highvolume/kyc",
                "categoryId":"DIGITALKYC",
                "page_key": "DEFAULT",
                "reportingData": {}
            },
            {
                "key": "balanceTransfer",
                "useDefault": true,
                "isGeneric": true,
                "useReportingData": false,
                "url": "/digital/servicing/balance-transfer",
                "categoryId":"BALANCE_TRANSFER",
                "page_key": "DEFAULT",
                "reportingData": {}
            },
            {
                "key": "accountDashboard",
                "useDefault": false,
                "isGeneric": false,
                "useReportingData": false,
                "url": "/digital/servicing/shellapp/#/account-dashboard",
                "categoryId":"ACCOUNT_DASHBOARD",
                "page_key": "MORTGAGE",
                "reportingData": {}
            },
          
        ]
       
}



